module.exports = __webpack_public_path__ + "static/img/youzhashipin.5fa9721d.png";